import type { ReactNode } from "react";

import "./auth.css";

type AuthShellProps = {
  title: ReactNode;
  description?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
};

export const AuthShell = ({
  title,
  description,
  footer,
  children,
}: AuthShellProps) => (
  <main className="auth-shell">
    <div className="auth-shell__frame">
      <a className="auth-brand" href="/" aria-label="Reelio home">
        reelio<span>.</span>
      </a>

      <section className="auth-panel">
        <div className="auth-intro">
          <h1>{title}</h1>
          {description ? <p>{description}</p> : null}
        </div>

        <div className="auth-form-stage">
          {children}
        </div>
      </section>

      <footer className="auth-footer">{footer}</footer>
    </div>
  </main>
);
